import { PipeTransform, Pipe } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';

@Pipe({
    name: 'join'
})
export class JoinPipe implements PipeTransform {

  constructor(private translate: TranslateService) { }

  transform(input: any, char: string = ',', prefix: string = null, postfix: string = null, translate: boolean = false): Observable<any> {
    if (!Array.isArray(input)) {
      if (!translate)
        return of(input);
      else
        return this.translate.get(input).pipe(map(result => result[input]));
    }

    if (prefix) {
      for (let i = 0; i < input.length; i++) {
        input[i] = prefix + input[i];
      }
    }

    if (postfix) {
      for (let i = 0; i < input.length; i++) {
        input[i] = input[i] + postfix;
      }
    }

    if (!translate)
      return of(input.join(char));
    else {
      return this.translate.get(input).pipe(map(result => Object.values(result).join(char)));
    }
  }

}
